document.addEventListener('alpine:init', () => {
  Alpine.data('pupIgData', () => ({
    region: 'eu-north-1',              
    bucket: 'sharkadoodle-pix2pix-generations', 
    accessKeyId: 'AKIASBGQLPMLOOFJMUHN',
    secretAccessKey: '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',
    key: '', // uploaded image path key
    watermarkReady: false,
    watermarkedUrl: null,
    clearUrl: null,
    sunflowerMarkedUrl: null,
    sunflowerCleanUrl: null,

    watchWatermark() {
      this.$watch('watermarkedUrl', (val) => {
        if (val) this.watermarkReady = true;
      });
    },


    // Supabase data
    
    _supabase: null,


    init() {
      const url = 'https://shmjvbgnblpwrsghxjpr.supabase.co'
      const key = 'sb_publishable_z9frF4Yd8QxAC19Lonpg7g_mSDAHBPT'
      this._supabase = supabase.createClient(url, key);

      AWS.config.update({
        region: this.region,
        accessKeyId: this.accessKeyId,
        secretAccessKey: this.secretAccessKey,
      });
    },
    // AWS credentials. Was done due to leak of time, i know that it's not okey

    async submitUser() {
      try {
        const { data, error } = await this._supabase
          .from('users') // Your target table
          .insert([
            {
              email: this.email,
              dog_name: this.pupName,
              generated_url: this.variants.find(variant => variant.id === this.selectedVariant).watermarked,
              original_photo_url: this.variants.find(variant => variant.id === this.selectedVariant).input_image,
              generated_door_b_url_watermarked: this.sunflowerMarkedUrl,
              generated_door_b_url_clean: this.sunflowerCleanUrl
            }
          ])
          .select();

        if (error) throw error;
      } catch (err) {
        // 5. Handle unexpected or thrown errors
        console.error('Supabase Insert Error:', err);
      }
    },

    async checkEmailUsed() {
      const emailToSearch = this.email.trim().toLowerCase();
      try {
        const { data, error } = await this._supabase
          .from('users') 
          .select('id')
          .eq('email', emailToSearch)
          .maybeSingle();

        if (error) throw error;

        this.isReturningUser = data !== null;

      } catch (err) {
        console.error('Supabase Query Error:', err);
      }
    },


    async downloadSelected(url) {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobURL = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobURL;
      link.download = this.photo.name;
      document.body.appendChild(link);
      link.click();
      
      document.body.removeChild(link);
    },

    // https://sharkadoodle-yolo-composite-e007ab9.app.beam.cloud/ping token: GTYUI4rLzXRThcnNKpSuk1-eQ6wElX65Z5yvWSu86L9UiO3Jb64Wq4OMzQzt37uHxTE1XqGcHpZq__Lh8KG71g==
    // https://sharkadoodle-style-face-only-8256783-v52.app.beam.cloud/ping token: wclFmmq7FMXAh1Qoi___OsXJyAd7u0B5wL4EbY-z0gbS33YR_cFNVXOOBY7NVzEcY59uTGRD5AtZsvgbUbzUTw==
    pingGen() {
      fetch('https://sharkadoodle-style-face-only-8256783-v73.app.beam.cloud/ping', {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer wclFmmq7FMXAh1Qoi___OsXJyAd7u0B5wL4EbY-z0gbS33YR_cFNVXOOBY7NVzEcY59uTGRD5AtZsvgbUbzUTw==',
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('Success:', data);
    })
    .catch(error => {
      console.error('Error:', error);
    });

    fetch('https://sharkadoodle-yolo-composite-e007ab9-v26.app.beam.cloud/ping', {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer GTYUI4rLzXRThcnNKpSuk1-eQ6wElX65Z5yvWSu86L9UiO3Jb64Wq4OMzQzt37uHxTE1XqGcHpZq__Lh8KG71g==',
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('Success:', data);
    })
    .catch(error => {
      console.error('Error:', error);
    });
   },
  async upload() {
    photoUrl = this.variants.find(variant => variant.id === this.selectedVariant).image
    const response = await fetch(photoUrl);
    const photo = await response.blob()
    if (!photo || !this.email) return;

    this.key = `uploads/${this.email}/${Date.now()}`;

    const s3 = new AWS.S3();
    s3.upload({
      Bucket: this.bucket,
      Key: this.key,
      Body: photo,
      ContentType: photo.type
      /* ACL: 'public-read' — uncomment if your bucket has ACLs enabled */
    })
    .send((err, data) => {
      this.uploading = false;
      if (err) {
        console.log('error', err)
      } else {
        console.log('uploaded')
      }
    });
  },

    step: 1,

    photo:    null,
    photoURL: null,
    photoURLWas:    window.pupIgStrings.photoURLWas,
    photoURLBecome: window.pupIgStrings.photoURLBecome,

    pupName: '',

    selectedVariant: null,
    variants: [
      { id: 1, emoji: '🐾', label: window.pupIgStrings.variant1_label },
      { id: 2, emoji: '🎄', label: window.pupIgStrings.variant2_label },
      { id: 3, emoji: '🌸', label: window.pupIgStrings.variant3_label },
      // { id: 4, emoji: '🏖️', label: window.pupIgStrings.variant4_label, bg: window.pupIgStrings.variant4_bg }
    ],

    email: '',
    isReturningUser: false,
    generating: false,

    handlePhoto(e) {
      const f = e.target.files[0];
      if (!f) return;
      this.photo = f;
      this.photoURL = URL.createObjectURL(f);
    },
    handleDrop(e) {
      e.preventDefault();
      const f = e.dataTransfer.files[0];
      if (!f || !f.type.startsWith('image/')) return;
      this.photo = f;
      this.photoURL = URL.createObjectURL(f);
    },
    async generate() {
      if (!this.pupName.trim() || this.generating) return;

      this.step = 4;
      console.log(this.photo);
      
      // this.generating = true;
        await this.upload()
      try {
        const apiPayload = {
          image_id: String(Date.now()),
          base_image_s3_key: this.key, 
          email: this.email, 
          pet_name: this.pupName.trim()
        };
        console.log(JSON.stringify(apiPayload))

        // https://sharkadoodle-yolo-composite-e007ab9.app.beam.cloud/composite
        // https://api.mockfly.dev/mocks/5f002a10-bd0b-4acd-b384-90e5a0b8191c/composite 
        const response = await fetch('https://sharkadoodle-beam-wake.sharkadoodle-wake.workers.dev/composite', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer wclFmmq7FMXAh1Qoi___OsXJyAd7u0B5wL4EbY-z0gbS33YR_cFNVXOOBY7NVzEcY59uTGRD5AtZsvgbUbzUTw=='
          },
          body: JSON.stringify(apiPayload)
        });

        if (!response.ok) {
          throw new Error(`API error! Status: ${response.status}`);
        }

        const data = await response.json()
        this.watermarkedUrl = data.results.flower_crown_hat_low.watermarked
        this.clearUrl = data.results.flower_crown_hat_low.clean
        this.sunflowerMarkedUrl = data.results.sunflower_glasses.watermarked
        this.sunflowerCleanUrl = data.results.sunflower_glasses.clean
        console.log(this.sunflowerCleanUrl)
        console.log(this.sunflowerMarkedUrl)
        this.percent = 100
        console.log('Composite images generation started:', data);
      } catch (error) {
        console.error('Failed to generate composite images:', error);
        // Handle error UI here
        
      }
    },

    async getBase64(file) {
      return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
      });
    },

    async generateOld() {
      this.step = 4;
    this.errorMessage = '';
    
    // https://sharkadoodle-style-face-only-8256783-v52.app.beam.cloud/generate
    // https://api.mockfly.dev/mocks/5f002a10-bd0b-4acd-b384-90e5a0b8191c/generate
    const url = 'https://sharkadoodle-beam-wake.sharkadoodle-wake.workers.dev/face';
    const token = 'wclFmmq7FMXAh1Qoi___OsXJyAd7u0B5wL4EbY-z0gbS33YR_cFNVXOOBY7NVzEcY59uTGRD5AtZsvgbUbzUTw==';
    const base64Image = await this.getBase64(this.photo);
   
    const payload = {
        email: this.email,
        encoded_images: [
            base64Image
        ]
    };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        
        const apiData = await response.json();
        
        if (apiData && apiData.images) {
            // Loop through the incoming API images
            apiData.images.forEach((item, index) => {
                // Check if an object already exists at this index in your Alpine array
                if (this.variants[index]) {
                    // Update only the image and watermarked properties directly
                    this.variants[index].image = item.original;
                    this.variants[index].watermarked = item.watermarked;
                    this.variants[index].input_image = item.input_image;
                }
            });
        }

    } catch (error) {
        this.errorMessage = 'Failed to update variants.';
        alert('Error while generating images')

        console.error(error);
    } finally {
      this.percent = 100;
      this.generating = false;
      this.step = 5
    }
    },

    async addImageToCart(productId) {
      const formData = {
            'items': [{
                'id': productId,
                'quantity': 1,
                'properties': {
                  'aiImage': this.clearUrl,
                  'numberOfDogs': 1
                }
            }]
        }
      
        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });
            const responseData = await response.json();

            // console.log(`Successfully added image ${Image} to the cart.`);
        } catch (error) {
          window.test = error
            console.error(`Error adding image ${Image}:`, error);
        }

        window.location = '/cart';
    },
    get emailValid() {
      return this.email.includes('@') && this.email.includes('.');
    },
    dotClass(n) {
      if (n < this.step)   return 'pup-dot pup-dot--done';
      if (n === this.step) return 'pup-dot pup-dot--active';
      return                      'pup-dot pup-dot--future';
    },
    lineClass(n) {
      return n < this.step ? 'pup-line pup-line--done' : 'pup-line pup-line--future';
    },

    //Loader
    percent: 30, 
    radius: 40,
    get circumference() { return 2 * Math.PI * this.radius },
    get strokeDashoffset() { return this.circumference - (this.percent / 100) * this.circumference },
    get isComplete() { return this.percent >= 100 },
    startLoader() {
      // Clear any existing interval just in case
      clearInterval(this.intervalId);
      
      this.intervalId = setInterval(() => {
        if (this.percent < 90) {
          this.percent++;
        } else {
          clearInterval(this.intervalId);
        }
      }, 400); } // 400ms * 100 steps = 40,000ms (40 seconds)
  }));
});